// Removed variant button implementation to prevent conflicts
// The variant button functionality is now handled in card-product.liquid using event delegation

document.addEventListener("DOMContentLoaded", function () {
  // Other theme-specific JavaScript can go here
});
